import axios, { InternalAxiosRequestConfig } from 'axios';

const API = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL })
// const API = axios.create({ baseURL: 'https://sanme-portfolio-c47c6ed45f5f.herokuapp.com' })

//This is going to be a function that's going to happen on each one of our request
API.interceptors.request.use(
  (req) => {
    const authData = localStorage.getItem('authData');

    if (authData && req.headers) {
      const token = JSON.parse(authData).token;
      req.headers.Authorization = `Bearer ${token}`;
    }

    return req;
  },
  (error) => Promise.reject(error)
);

export interface PostDataParams{
    username?: string;
    password?: string;
}

export interface ApiParams {
    currentPage?: number;
    page?: any;
    id?: any;
    userId?: any;
    otp?: any;
    searchQuery?: any;
    emailAddress?: any;
    postData?: any;
    postId?: any;
}

const admins           = '/admins'
const contactUs        = '/contact-us'
const newsLetter       = "/news-letter"

//admins
export const fetchAdmins               = ({page}: ApiParams) => API.get(`${admins}?page=${page}`)
export const fetchAdmin                = ({id}: ApiParams) => API.get(`${admins}/admin/${id}`)
export const createAdmin               = ({postData}: ApiParams) => API.post(`${admins}/signup`, postData)
export const updateAdmin               = ({id, postData}: ApiParams) => API.patch(`${admins}/update/${id}`, postData)
export const fetchAdminsBySearch       = ({searchQuery, page}: ApiParams) => API.get(`${admins}/search?searchQuery=${searchQuery.search || 'none'}&page=${page}`)
export const deleteAdmin               = ({id}: ApiParams) => API.delete(`${admins}/delete/${id}`)
export const verifyAdminRegEmail       = ({id, emailAddress, otp}: ApiParams) => API.get(`${admins}/admin/${id}/verify/${emailAddress}/otp/${otp}`)
export const resendAdminVerification   = ({emailAddress}: ApiParams) => API.post(`${admins}/resend-verification/${emailAddress}`)
export const verifyAdminEmailPassword  = ({emailAddress}: ApiParams) => API.post(`${admins}/verify-email-password/${emailAddress}`)
export const passwordResetAdmin        = ({id, postData}: ApiParams) => API.put(`${admins}/reset/${id}`, postData)
export const signInAdmin               = (postData: PostDataParams ) => API.post(`${admins}/signin`, postData)
//-------------------------------------------------------------------------------------------------------------------------------

//contact us
export const createContactUsMessage = ({postData}: ApiParams) => API.post(`${contactUs}/create`, postData)
export const fetchContactMessage    = ({id}: ApiParams) => API.get(`${contactUs}/message/${id}`)
export const fetchContactMessages   = ({page}: ApiParams) => API.get(`${contactUs}?page=${page}`)
export const deleteContactUsMessage = ({id}: ApiParams) => API.delete(`${contactUs}/delete/${id}`)
//-------------------------------------------------------------------------------------------------------------------------------

//newsletter
export const createNewsLetter      = ({postData}: ApiParams) => API.post(`${newsLetter}/create`, postData)
export const fetchNewsLetter       = ({page}: ApiParams) => API.get(`${newsLetter}?page=${page}`)